import { IGetAnnoncesRequestModel, IGetAnnoncesResponseModel } from "./_models"
import axios from "axios"
import { CONST_API_RECRUITMENT_OFFERS_GET_LISTING_ENDPOINT } from "../../../../../endpoints"

export function annoncesListingRequest(filters: IGetAnnoncesRequestModel) {
     return axios.post<IGetAnnoncesResponseModel>(CONST_API_RECRUITMENT_OFFERS_GET_LISTING_ENDPOINT, filters)
}
